export const POSTHOG_REGION_ORIGINS = {
    us: 'https://us.posthog.com',
    eu: 'https://eu.posthog.com',
};
/** HTTP methods an admin can opt a connection into. Single source of truth for
 *  the backend validation allowlist and the frontend method pickers. */
export const EXTERNAL_CONNECTION_METHODS = [
    'GET',
    'POST',
    'PUT',
    'PATCH',
    'DELETE',
];
/** Backend-owned identity headers. Never configurable by apps or connections. */
export const EXTERNAL_CONNECTION_IDENTITY_HEADERS = {
    appId: 'X-Lightdash-App-Id',
    userEmail: 'X-Lightdash-User-Email',
    userId: 'X-Lightdash-User-Id',
    organizationId: 'X-Lightdash-Organization-Id',
    projectId: 'X-Lightdash-Project-Id',
};
/** Bounds for a connection's custom request headers — shared by backend
 *  validation and the frontend form so both reject the same shapes. */
export const CUSTOM_HEADER_LIMITS = {
    maxCount: 20,
    maxNameChars: 128,
    maxValueChars: 1024,
};
/** Header names custom request headers may never use: routing/framing headers
 *  the proxy owns, plus credential-shaped names — header values are plaintext
 *  config returned by the read API, so secrets belong in the encrypted secret. */
export const FORBIDDEN_CUSTOM_HEADER_NAMES = [
    'host',
    'content-length',
    'content-type',
    'connection',
    'transfer-encoding',
    'te',
    'trailer',
    'upgrade',
    'keep-alive',
    'expect',
    'authorization',
    'proxy-authorization',
    'proxy-connection',
    'cookie',
    'x-api-key',
    'api-key',
    'x-auth-token',
    'x-access-token',
    ...Object.values(EXTERNAL_CONNECTION_IDENTITY_HEADERS).map((name) => name.toLowerCase()),
];
/** Server-applied defaults for the optional numeric limits. */
export const EXTERNAL_CONNECTION_DEFAULTS = {
    responseMaxBytes: 1048576,
    requestMaxBytes: 262144,
    timeoutMs: 10000,
};
export const isExternalFetchDocumentContext = (context) => !!context && 'documentUuid' in context;
//# sourceMappingURL=types.js.map